
export { Accordion } from "/home/runner/work/apollo/apollo/packages/core/ui/src/templates/accordion/accordion.tsx"